const DB_NAME = "safers-notices";
const STORE = "notices";
const NOTICE_TTL_MS = 3 * 24 * 60 * 60 * 1000;

export interface StoredNotice {
  id: string;
  title: string;
  message: string;
  receivedAt: string;
  siteUuid: string;
}

function openDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE, { keyPath: "id" });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function putNotice(notice: StoredNotice): Promise<void> {
  const db = await openDb();
  await new Promise<void>((resolve) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).put(notice);
    tx.oncomplete = () => resolve();
    tx.onerror = () => resolve();
  });
  db.close();
}

export async function getNotices(siteUuid: string): Promise<StoredNotice[]> {
  let all: StoredNotice[] = [];
  try {
    const db = await openDb();
    all = await new Promise<StoredNotice[]>((resolve) => {
      const tx = db.transaction(STORE, "readonly");
      const req = tx.objectStore(STORE).getAll();
      req.onsuccess = () => resolve((req.result as StoredNotice[]) ?? []);
      req.onerror = () => resolve([]);
    });
    db.close();
  } catch {
    return [];
  }
  const now = Date.now();
  return all
    .filter((n) => !n.siteUuid || n.siteUuid === siteUuid)
    .filter((n) => now - Date.parse(n.receivedAt) < NOTICE_TTL_MS)
    .sort((a, b) => b.receivedAt.localeCompare(a.receivedAt));
}
